import {Component, Input, OnInit} from '@angular/core';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {CalendarService} from 'src/app/calendar/calendar.service';
import {IUser} from 'src/app/users/users';

import {LabelingService} from '../../labeling.service';
import {WidgetService} from '../widget.service';
import {IVisitCounterWidget} from '../widgets';


@Component({
    selector: 'app-visit-counter-widget',
    templateUrl: './visit-counter-widget.component.html',
    styleUrls: ['./visit-counter-widget.component.scss'],
    standalone: false
})
export class VisitCounterWidgetComponent implements OnInit {

  _selectedUser: any;

  private MAX_CHARS_STORE_NAME = 15;
  @Input() public set selectedUser(user: any) {
    this._selectedUser = user;
    this.retrieveData();
  }

  private destroyed$: Subject<void> = new Subject<void>();
  widgetHeaderData = [
    this.labelingService.getStoreSentenceLabel(marker('Store name'), marker('name')),
    this.translateService.stream(marker('Days Left')),
    this.translateService.stream(marker('MTD')),
  ];
  widgetData: IVisitCounterWidget[] = [];

  filteredValues: IUser[] = [];
  isLoading = false;

  constructor(
    public service: WidgetService,
    public translateService: TranslateService,
    private calendarService: CalendarService,
    public labelingService: LabelingService,
  ) {
  }

  ngOnInit() {
    this.retrieveData();
  }

  calculateClasses(row) {
    if (row.visitsToComplete <= 0) {
      return {
        highlighted: true,
      };
    }
  }

  private retrieveData() {
    if (this._selectedUser !== undefined) {
      if (!this._selectedUser.isDownlineUser) {
        this.retrieveMyVisitCounterData();
      } else {
        this.retrieveDownLineVisitCounterData(this._selectedUser.userId);
      }
    }
  }

  private retrieveDownLineVisitCounterData(userId: number) {
    this.service.retrieveDownLineVisitCounterData(userId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (response) => {
          this.widgetData = response;
        },
      );
  }

  getRowDetails(row) {
    const event = this.calendarService.transformVisitCounterRowToMICalendarEvent(row);
    return JSON.stringify(event);
  }

  private retrieveMyVisitCounterData() {
    this.service.retrieveMyVisitCounterData()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (response) => {
          this.widgetData = response;
        },
      );
  }

  needsTruncation(storeName: string): boolean {
    let nameParts = storeName.split(" ");
    let hasBigParts = false;
    nameParts.forEach( namePart => {
      if (namePart.length > this.MAX_CHARS_STORE_NAME + 1) {
        hasBigParts = true;
      }
    });
    return hasBigParts;
  }

  truncate(storeName: string) {
    return storeName.slice(0, this.MAX_CHARS_STORE_NAME) +'…';
  }
}
